<template>
  <div class="display">
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center targetFirst_loading">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else>
      <v-layout row wrap class="layoutTraficVisiteurs bigChat">


      <!-- liste des contacts -->
        <v-flex 
          v-if="
            (!dataContactSelected && $vuetify.breakpoint.xsOnly) ||
           !$vuetify.breakpoint.xsOnly
          " 
          xs12
          :class="{
              sm3 : dataContactSelected,
              listeAgentsOverflow : dataContactSelected
              }"
          class="traficListVisiteurs fill-height"
        >
          <v-card>
              <v-card-title class="">
                <!-- menu classement -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :loading="loading"
                      :disabled="loading"
                      color="primary"
                      class="white--text"
                      v-on="on"
                    >
                      <span v-if="!dataContactSelected  && !$vuetify.breakpoint.xsOnly">{{$t('ranking')}}</span>
                      <v-icon 
                        v-if="typeClassement == 'all'"
                        :right="!dataContactSelected  && !$vuetify.breakpoint.xsOnly"
                        dark
                      >groups</v-icon>
                      <v-icon 
                        v-else-if="typeClassement == 'reseaux'"
                        :right="!dataContactSelected  && !$vuetify.breakpoint.xsOnly"
                        dark
                      >language</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in itemsClassement"
                      :key="index"
                      @click="getAllContacts(item.type)"
                    >
                      <v-list-tile-title>
                        
                        <v-icon 
                          :left="!dataContactSelected  && !$vuetify.breakpoint.xsOnly"
                        >{{item.icone}}</v-icon>
                        <span v-if="!dataContactSelected  && !$vuetify.breakpoint.xsOnly">{{item.title}}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-card-title>

              <v-card-text>
        <!-- classement par tus les contacts  --> 
                <v-expansion-panel
                  v-if="typeClassement == 'all'"
                  focusable
                  :expand=true
                >
                  <v-expansion-panel-content
                    v-for="(alpha,i) in listeAllContacts"
                    :key="i"
                  >
                    <template v-if="alpha.liste.length" v-slot:header>
                      <div>
                        <v-avatar
                          size="36px"
                          class="grey lighten-1 white--text title"
                        >{{alpha.item}}</v-avatar>
                        <i class="grey--text"> {{alpha.liste.length + ' contact(s)'}}</i>
                      </div>
                    </template>
                    <v-card v-if="alpha.liste.length">
                      <v-list two-line dense class="listeTraficVisiteurs">
                        <div class="wz_wrapChips" v-for="(contact, i) in alpha.liste" :key="i">
                          <v-flex xs12 sm12
                            class="visiteurFiltrer"
                          >
                            <v-list-tile
                              :class="{ 'light-blue lighten-4': contactSelected.visiteurID == contact.userId,  }"
                              class="listContacts"
                              ripple
                              :key="contact.id"
                              @click="openMessageVisiteur(myId, contact)"
                            >
                              <v-list-tile-avatar>
                                <wz-avatar
                                  v-if="!dejaEnChat && contact.network == 'moon' || !dejaEnChat && !contact.network"
                                  :username="'#' + contact.userId"
                                  size="38px"
                                  class="pl-1"
                                ></wz-avatar>
                                <wz-avatar
                                  v-else-if="!dejaEnChat && contact.network == 'facebook'"
                                  :src="contact.avatar"
                                  :username="contact.firstName + ' ' + contact.lastName"
                                  size="38px"
                                  class="pl-1"
                                ></wz-avatar>
                                <wz-avatar
                                  v-else-if="!dejaEnChat && contact.network == 'whatsapp'"
                                  :src="contact.avatar"
                                  :username="contact.profileName"
                                  size="38px"
                                  class="pl-1"
                                ></wz-avatar>
                                <wz-avatar
                                  v-else-if="!dejaEnChat && !istypingVisiteur && contact.message && contact.userId != contactSelected.visiteurID"
                                  :username="'#' + contact.userId"
                                  size="38px"
                                  lastMessage
                                ></wz-avatar>
                                <wz-avatar
                                  v-else-if="!dejaEnChat && istypingVisiteur"
                                  :isTyping="istypingVisiteur"
                                  :username="'#' + contact.userId"
                                  size="38px"
                                  chip
                                ></wz-avatar>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title>
                                  <div v-if="contact.network == 'moon' || !contact.network" class="wz_nameVisiteur">
                                    {{contact.userId}} 
                                  </div>
                                  <div v-if="contact.network == 'email'" class="wz_nameVisiteur">
                                    {{contact.userId}} 
                                  </div>
                                  <div v-else-if="contact.network == 'facebook'" class="wz_nameVisiteur">
                                    {{contact.firstName}} {{contact.lastName}} 
                                  </div>
                                  <div v-else-if="contact.network == 'whatsapp'" class="wz_nameVisiteur">
                                    {{contact.profileName}} 
                                  </div>
                                </v-list-tile-title>
                                
                                <v-list-tile-sub-title>
                                    <div
                                      slot="activator"
                                      class="wz_alertFiltre"
                                    >
                                      <v-icon v-if="contact.network == 'moon' || !contact.network" size="20" class="secondary--text text--lighten-1">chat_bubble</v-icon>
                                      <v-icon v-else-if="contact.network == 'email'" size="20" class="blue-grey--text lighten-2">email</v-icon>
                                      <v-icon v-else-if="contact.network == 'facebook'" size="20" color="blue accent-4--text" class=" ">mdi-facebook-messenger</v-icon> 
                                      <v-icon v-else-if="contact.network == 'whatsapp'" size="20" color="green accent-4--text" class=" ">mdi-whatsapp</v-icon>
                                    </div>
                                  
                                </v-list-tile-sub-title>
                              </v-list-tile-content>

                              <v-list-tile-action>
                                <v-btn flat slot="activator" icon color="accent"
                                  @mouseover.native="overMenu = true"
                                  @mouseleave.native="overMenu = false"
                                  @click="suppContact({
                                    'network': contact.network,
                                    'Id': contact.id,
                                    'userId': contact.userId,
                                    'timestamp': contact.timeStamp
                                  })"
                                >
                                  <v-icon large color="grey lighten-1">close</v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-flex>
                        </div>
                      </v-list>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

        <!-- classement par reseaux sociaux  --> 
                <v-expansion-panel
                  v-else
                  focusable
                  :expand=true
                >
                  <v-expansion-panel-content
                    v-for="(reseau,i) in listeAllContactsReseaux"
                    :key="i"
                  >
                    <template v-slot:header>
                      <div>
                        <v-icon x-large v-if="reseau.network == 'facebook'"  color="blue accent-4--text" >mdi-facebook-messenger</v-icon> 
                        <v-icon x-large v-else-if="reseau.network == 'whatsapp'" color="green accent-4--text" >mdi-whatsapp</v-icon>
                        <i class="grey--text"> {{reseau.network}}</i>
                      </div>
                    </template>
                    <v-card v-if="reseau.liste.length">

                      <v-expansion-panel
                        focusable
                        :expand=true
                      >
                        <v-expansion-panel-content
                          v-for="(alpha,i) in reseau.liste"
                          :key="i"
                        >
                          <template v-if="alpha.liste.length" v-slot:header>
                            <div>
                              <v-avatar
                                size="36px"
                                class="white gey--text title"
                              >{{alpha.item}}</v-avatar>
                              <i class="grey--text"> {{alpha.liste.length + ' contact(s)'}}</i>
                            </div>
                          </template>
                          <v-card v-if="alpha.liste.length">
                            <v-list two-line dense class="listeTraficVisiteurs">
                              <div class="wz_wrapChips" v-for="(contact, i) in alpha.liste" :key="i">
                                <v-flex xs12 sm12
                                  class="visiteurFiltrer"
                                >
                                  <v-list-tile
                                    :class="{ 'light-blue lighten-4': contactSelected.visiteurID == contact.userId,  }"
                                    class="listContacts"
                                    ripple
                                    :key="contact.id"
                                    @click="openMessageVisiteur(myId, contact)"
                                  >
                                    <v-list-tile-avatar>
                                      <wz-avatar
                                        v-if="!dejaEnChat && contact.network == 'moon' || !dejaEnChat && !contact.network"
                                        :username="'#' + contact.userId"
                                        size="38px"
                                        class="pl-1"
                                      ></wz-avatar>
                                      <wz-avatar
                                        v-else-if="!dejaEnChat && contact.network == 'facebook'"
                                        :src="contact.avatar"
                                        :username="contact.firstName + '' + contact.lastName"
                                        size="38px"
                                        class="pl-1"
                                      ></wz-avatar>
                                      <wz-avatar
                                        v-else-if="!dejaEnChat && contact.network == 'whatsapp'"
                                        :src="contact.avatar"
                                        :username="contact.profileName"
                                        size="38px"
                                        class="pl-1"
                                      ></wz-avatar>
                                      <wz-avatar
                                        v-else-if="!dejaEnChat && !istypingVisiteur && contact.lastName.message && contact.lastName.userId != contactSelected"
                                        :username="'#' + contact.lastName.userId"
                                        size="38px"
                                        lastMessage
                                      ></wz-avatar>
                                      <wz-avatar
                                        v-else-if="!dejaEnChat && istypingVisiteur"
                                        :isTyping="istypingVisiteur"
                                        :username="'#' + contact.lastName.userId"
                                        size="38px"
                                        chip
                                      ></wz-avatar>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                      <v-list-tile-title>
                                        <div v-if="contact.network == 'moon' || !contact.network" class="wz_nameVisiteur">
                                          {{contact.userId}} 
                                        </div>
                                        <div v-if="contact.network == 'email'" class="wz_nameVisiteur">
                                          {{contact.userId}} 
                                        </div>
                                        <div v-else-if="contact.network == 'facebook'" class="wz_nameVisiteur">
                                          {{contact.firstName}} {{contact.lastName}} 
                                        </div>
                                        <div v-else-if="contact.network == 'whatsapp'" class="wz_nameVisiteur">
                                          {{contact.profileName}} 
                                        </div>
                                      </v-list-tile-title>
                                      
                                      <v-list-tile-sub-title>
                                          <div
                                            slot="activator"
                                            class="wz_alertFiltre"
                                          >
                                            <v-icon v-if="contact.network == 'moon' || !contact.network" size="20" class="secondary--text text--lighten-1">chat_bubble</v-icon>
                                            <v-icon v-else-if="contact.network == 'email'" size="20" class="blue-grey--text lighten-2">email</v-icon>
                                            <v-icon v-else-if="contact.network == 'facebook'" size="20" color="blue accent-4--text" class=" ">mdi-facebook-messenger</v-icon> 
                                            <v-icon v-else-if="contact.network == 'whatsapp'" size="20" color="green accent-4--text" class=" ">mdi-whatsapp</v-icon>
                                          </div>
                                        
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                      <v-btn flat slot="activator" icon color="accent"
                                        @mouseover.native="overMenu = true"
                                        @mouseleave.native="overMenu = false"
                                        @click="suppContact({
                                          'network': contact.network,
                                          'Id': contact.id,
                                          'userId': contact.userId,
                                          'timestamp': contact.timeStamp
                                        })"
                                      >
                                        <v-icon large color="grey lighten-1">close</v-icon>
                                      </v-btn>
                                    </v-list-tile-action>
                                  </v-list-tile>
                                </v-flex>
                              </div>
                            </v-list>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>



                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex v-if="dataContactSelected" xs12 sm9 class="traficInfosVisiteur fill-height">
          <div v-if="loadingHistoChat" class="wz_loadingChat text-xs-center">
            <v-progress-circular :size="70" :width="1" indeterminate class="primary--text"></v-progress-circular>
          </div>
          <wz-view-chat
            v-else
            :datasViewPupitre="dataVisiteurComputed"
            :placesPupitre="1"
            @click.native="focusView({'view': 1, 'visiteurID': contactSelected.visiteurID})"
            @activeCobrowsing="openCobrowsing(0)"
            @stopCobrowsing="closeCobrowsing(0)"
            @MAJHistoChat="MAJHistoChat"
          ></wz-view-chat>
        </v-flex>
      </v-layout>
    </div>


    <!-- dialogBox de confirmation de suppression-->
    <v-dialog v-model="dialogSupContact" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('deleteContact') | cap }}</v-card-title>
        <v-card-text>
          {{ $t('delContact') | cap }}
        </v-card-text>
        <!-- $t('contentDialogSessionClose') -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="dialogSupContact=false">{{$t('no')}}</v-btn>
          <v-btn
            class="white--text darken-1"
            :loading="loadingSupp"
            :disabled="loadingSupp"
            color="accent"
            @click="confirmSuppContact()"
          >
          {{$t('yes')}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<style>
.targetFirst_loading {
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  position: fixed;
}
.layoutTraficVisiteurs.smallChat .traficInfosVisiteur {
    -ms-flex-preferred-size: 75% !important;
    flex-basis: 75% !important;
    max-width: 75% !important;
}

.visiteurAttente .v-avatar {
    float: left;
}
.layoutTraficVisiteurs {
  height: calc(100vh - 104px) !important;
}
/*
.cardTraficVisiteurs {
  height:100% !important;
}
*/
.wz_contentListesVisiteurs {
  height: calc(100vh - 176px);
  overflow: auto;
  position: relative;
}
.wz_loadingChat {
  top: calc(50% - 35px);
  position: relative;
}
</style>

<script>
import _ from 'lodash'
import { DOMAINE } from '../../constants'
import { mapState, mapGetters, mapMutations } from 'vuex'
import _watcheebox from '../watcheebox/watcheebox.js'
import monitor from '../../mixins/monitor'
import moment from 'moment'
export default {
  mixins: [monitor],

  data () {
    return {
      domaine: DOMAINE,
      dialogSupContact: false,
      loadingSupp: false,
      loading: false,
      chatStatus: false,
      listeComputedMessages: [],
      loadingHistoChat: false,
      visiteurData: {},
      dejaEnChat: 0,
      istypingVisiteur: 0,
      contactIdSelected: 0,
      contactUserIdSelected: 0,
      contactNetwork: 0,
      contactTimestamp: 0,
      resAjx: null,
      typeClassement: 'all',
      numMessageSite: [],
      /**
       * Liste des agents affichés
       * @type {Array}
       */
      agents: [],
      itemsClassement: [
        { title: this.$t('allContacts'), type: 'all', icone: 'groups' },
        { title: this.$t('bySocialNetworks'), type: 'reseaux', icone: 'language' }
      ],
      itemsClassementPeon: [
        { title: this.$t('allContacts'), type: 'all', icone: 'groups' },
        { title: this.$t('bySocialNetworks'), type: 'reseaux', icone: 'language' }
      ]
    }
  },

  created () {
    if (this.hideTabVisitors) {
      this.$router.push({ path: '/trafic/contact' })
    }
    // clear les data du visiteur deja ouvert pour ne pas ouvrire par defaut une fenetre chat avec des erreurs js
    this.$store.commit('_StoreWatcheeBox/CLEAR_CONTACT_OPEN')
    // recuperation de la liste des contacts de l'entreprise
    this.loadAllContact(this.$store.state._User.entId)
  },

  mounted () {
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', [
      'SET_CONTACT_ALL_DATA',
      'SET_LIST_CONTACT_RESEAUX',
      'SET_DEL_CONTACT_RESEAU'
    ]),

    isItMe (id) {
      return Number.parseInt(this.$store.state._User.id) === Number.parseInt(id)
    },

    // ----------------------------------------------------------------------------
    // supprime un contact
    // ----------------------------------------------------------------------------
    suppContact (data) {
      console.log('data', data)
      // this.messageIdSelected = Number.parseInt(data.messageId) ? Number.parseInt(data.messageId) : 0
      this.contactIdSelected = data.Id
      this.contactUserIdSelected = data.userId
      this.contactNetwork = data.network
      this.contactTimestamp = data.timestamp
      // affiche la fenetre de confirmation
      this.dialogSupContact = true
    },

    // ----------------------------------------------------------------------------
    // Affiche la liste de tous les contacts
    // ----------------------------------------------------------------------------
    getAllContacts (classement) {
      console.log('getAllContacts', classement)
      this.typeClassement = classement
      this.$cookie.set('wz-clsContact', classement, { expires: '1Y' })
    },

    // ----------------------------------------------------------------------------
    // Il faut mettre à jour l'historique de chat pour les message en attente uniquement
    // ----------------------------------------------------------------------------
    MAJHistoChat (data) {
      console.log('MAJHistoChat', data)
      this.MonitorMajHistoChat(data)
    },

    // ------------------------------------------------------------------------------
    // Chargement de tous les contacts
    // ------------------------------------------------------------------------------
    loadAllContact (entrepriseID) {
      // console.log('get messages', this.user.id)
      this.loading = true
      this.axios
      .get(
        'get/chats_allContact.php?entrepriseId=' +
          entrepriseID
      )
      .then(response => {
        console.log('response', response)
        if (response.data.length) {
          this.SET_LIST_CONTACT_RESEAUX({
            'listeContact': response.data,
            'agentId': entrepriseID
          })
        } else {
          console.log('Aucun message en attente')
        }
        // console.log('this.listeMessages', this.listeMessages)
        // this.loading = false
        // console.log('length', this.listeMessages.length)
        this.loading = false
      })
      .catch(_ => {
      })
      .then(_ => {
      })
    },

    // ----------------------------------------------------------------------------
    // confirmation de la suppression du message
    // ----------------------------------------------------------------------------
    confirmSuppContact () {
      console.log('confirmSuppContact', this.contactIdSelected)
      let suppId = this.contactIdSelected
      let userId = this.contactUserIdSelected
      let network = this.contactNetwork
      let timestamp = this.contactTimestamp
      let dataToPost = new window.FormData()
      dataToPost.append('contactId', suppId)
      dataToPost.append('network', network)
      dataToPost.append('visiteurId', userId)
      dataToPost.append('timestamp', timestamp)
      // efface ce contact
      this.axios
      .post('post/suppContactReseaux.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      // console.log('suppId 1', suppId)
      // les changements été pris en compte
      // il faut retirer le contact de la liste
      .then(response => {
        // recupère l'index du message supprimé
        this.SET_DEL_CONTACT_RESEAU({
          'userId': userId
        })
      })
      .catch(_ => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('modifFailure'),
          context: 'error'
        })
      })
      .then(_ => {
        // stop le loading du bouton
        this.loadingSupp = false
        // ferme la fenetre dialog
        this.dialogSupContact = false
        this.messageIdSelected = 0
        this.messageAgentIdSelected = 0
        this.messageVisiteurIdSelected = 0
        this.messageSelected = ''
        this.messageTimestamp = 0
      })
    },

    // ----------------------------------------------------------------------------
    // Si ce visiteur est deja en chat
    // Check avec quel agent ce visiteur est en chat
    // si c'est moi j'ouvre le chat si c'est un autre agent j'ouvre une dialogBox
    // ----------------------------------------------------------------------------
    openMessageVisiteur (agentId, data) {
      agentId = Number.parseInt(agentId)
      console.log('openMessageVisiteur', agentId)
      console.log('openMessageVisiteur data', data)
      // console.log('entId', this.user.entId)
      if (this.overMenu) return
      if (this.contactSelected.visiteurID === data.userId) {
        // return // pour eviter d'ouvrir un chat deja ouvert
      } else {
        console.log('load histo chat')
        this.loadingHistoChat = true
        // --------------- DEMANDE HISTORIQUE DE CHAT
        _watcheebox
          .firstLoadHistoChat({
            chatSession: data.userId,
            entrepriseId: this.user.entId
          })
          .then(histoChat => {
            console.log('histoChat', histoChat)
            let visClone = _.cloneDeep(data)
            visClone.visiteurID = data.userId
            visClone.histoChat = histoChat
            // enregistre les donnée du visiteur dans le store
            // console.log('set visiteur openchat', visClone)
            this.showChat(visClone)
            this.visiteurData = visClone // mise à jour des data visiteur selectionné
            // mise à jour du store pour les donnée visiteur offline
            let visOfflineClone = _.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened)
            visOfflineClone.agentIdSelected = agentId
            visOfflineClone.histoChat = histoChat
            visOfflineClone.visiteurID = visClone.visiteurID
            console.log('visOfflineClone', visOfflineClone)
            this.SET_CONTACT_ALL_DATA(visOfflineClone)
          })
          .catch(e => {
            console.error(e)
          })
        // -------------------------------------------
      }
    },

    // ----------------------------------------------------------------------------
    // chargement avant affichage du chat et des infos
    // ----------------------------------------------------------------------------
    loadingChat (visiteurInfos) {
      // this.visSelected = visiteurInfos.visiteurID // indique quel visiteur est selectionné
      this.loadingHistoChat = true
    },

    // ----------------------------------------------------------------------------
    // affiche le chat
    // ----------------------------------------------------------------------------
    showChat (visiteurInfos) {
      // console.log('showChat', visiteurInfos)
      this.loadingHistoChat = false
      this.chatStatus = true // iframe visible
      // Connection à la room visiteur
      _watcheebox.clientConnectRoom({'roomName': 'chat_' + visiteurInfos.visiteurID})
      // Enregistre dans le store l'id du visiteur
      this.$store.commit('_StoreWatcheeBox/VISITEUR_ADD_CHAT', {sessionID: visiteurInfos.visiteurID, dataVisiteur: visiteurInfos})
      // this.startCheckInfos() // start le monitor
      // indique que la fiche visiteur est ouverte
      this.$store.commit('_StoreWatcheeBox/OPEN_FICHE_VISITEUR', visiteurInfos)
    },

    dateMessageFromNow (date) {
      // var dateString = moment.unix(date)
      // console.log('date', dateString)
      // return dateString
      return moment.unix(date).fromNow()
    }
  },

  beforeDestroy () {
  },

  watch: {
  },

  computed: {
    ...mapGetters('_User', ['user', 'fullName', 'account', 'id']),
    ...mapState('_User', ['hideTabVisitors', 'colleagues', 'id']),
    ...mapState('_StoreWatcheeBox', [
      'listeAllVisiteurs',
      'newMessage',
      'mySocketID',
      'listeChatAgent',
      'contactSelected',
      'allDataVisiteurOpened',
      'status',
      'listeContactReseaux'
    ]),

    // mon id
    myId () {
      return this.id
    },

    // affiche si l'object contactSelected est remplis ou non
    dataContactSelected () {
      return Object.keys(this.contactSelected).length
    },

    userRights () {
      console.log('this.account.rights', this.account.rights)
      return this.account.rights
    },

    // Affiche la liste de tous les contact reseaux sociaux
    // il faut affiner avec les caractères accentués
    // et les chiffres et symboles
    listeAllContactsReseaux () {
      console.log('typeClassement', this.typeClassement)
      console.log('listeAllContactsReseaux', this.$store.state._StoreWatcheeBox.listeContactReseaux)
      let res = []
      // liste les reseaux sociaux
      _.forEach(
        this.$store.state._StoreWatcheeBox.listeContactReseaux,
        (reseaux, key) => {
          // listeAllContacts.push(contact)
          if (reseaux.network) {
            res.push(reseaux.network)
          }
        }
      )
      // retire les doublons
      let resTrie = Array.from(new Set(res))
      // création du nouveaux tableau reseauxSociaux
      // il faut améliorer le tableau avec des noms qui commence par des chiffres ou autre que des lettres
      let reseauxSociaux = []
      _.forEach(
        resTrie,
        (reseauName, key) => {
          reseauxSociaux.push(
            {
              'network': reseauName,
              'liste': [
                {'item': 'a', 'liste': []},
                {'item': 'b', 'liste': []},
                {'item': 'c', 'liste': []},
                {'item': 'd', 'liste': []},
                {'item': 'e', 'liste': []},
                {'item': 'f', 'liste': []},
                {'item': 'g', 'liste': []},
                {'item': 'h', 'liste': []},
                {'item': 'i', 'liste': []},
                {'item': 'j', 'liste': []},
                {'item': 'k', 'liste': []},
                {'item': 'l', 'liste': []},
                {'item': 'm', 'liste': []},
                {'item': 'n', 'liste': []},
                {'item': 'o', 'liste': []},
                {'item': 'p', 'liste': []},
                {'item': 'q', 'liste': []},
                {'item': 'r', 'liste': []},
                {'item': 's', 'liste': []},
                {'item': 't', 'liste': []},
                {'item': 'u', 'liste': []},
                {'item': 'v', 'liste': []},
                {'item': 'w', 'liste': []},
                {'item': 'x', 'liste': []},
                {'item': 'y', 'liste': []},
                {'item': 'z', 'liste': []},
                {'item': '0', 'liste': []},
                {'item': '1', 'liste': []},
                {'item': '2', 'liste': []},
                {'item': '3', 'liste': []},
                {'item': '4', 'liste': []},
                {'item': '5', 'liste': []},
                {'item': '6', 'liste': []},
                {'item': '7', 'liste': []},
                {'item': '8', 'liste': []},
                {'item': '9', 'liste': []},
                {'item': '?', 'liste': []},
                {'item': '#', 'liste': []},
                {'item': '@', 'liste': []}
              ]
            }
          )
        }
      )
      // console.log('reseauxSociaux', reseauxSociaux)
      // ajoute les contact dans le bon reqseau sociale
      _.forEach(
        reseauxSociaux,
        (reseau, key) => {
          // let newAlphaListe = alphaListe
          _.forEach(
            this.$store.state._StoreWatcheeBox.listeContactReseaux,
            (contact, key2) => {
              // listeAllContacts.push(contact)
              if (contact.network === reseau.network) {
                // si c'est le bon reseau on le classe à la bonne lettre
                _.forEach(
                  reseau.liste,
                  (alpha, key3) => {
                    // si contact whatsapp
                    if (contact.profileName) {
                      // console.log('1er :', contact.profileName.substring(0, 1).toLowerCase())
                      if (alpha.item === contact.profileName.substring(0, 1).toLowerCase()) {
                        reseau.liste[key3].liste.push(contact)
                      }
                    // sinon c'est facebook
                    } else {
                      if (alpha.item === contact.lastName.substring(0, 1).toLowerCase()) {
                        reseau.liste[key3].liste.push(contact)
                      }
                    }
                  }
                )
              }
            }
          )
        }
      )
      console.log('reseauxSociaux', reseauxSociaux)
      return reseauxSociaux
    },

    // Affiche la liste de tous les contact reseaux sociaux
    // il faut affiner avec les caractères accentués
    // et les chiffres et symboles
    listeAllContacts () {
      console.log('typeClassement', this.typeClassement)
      console.log('listeAllContacts', this.$store.state._StoreWatcheeBox.listeContactReseaux)
      let alphaListe = [
          {'item': 'a', 'liste': []},
          {'item': 'b', 'liste': []},
          {'item': 'c', 'liste': []},
          {'item': 'd', 'liste': []},
          {'item': 'e', 'liste': []},
          {'item': 'f', 'liste': []},
          {'item': 'g', 'liste': []},
          {'item': 'h', 'liste': []},
          {'item': 'i', 'liste': []},
          {'item': 'j', 'liste': []},
          {'item': 'k', 'liste': []},
          {'item': 'l', 'liste': []},
          {'item': 'm', 'liste': []},
          {'item': 'n', 'liste': []},
          {'item': 'o', 'liste': []},
          {'item': 'p', 'liste': []},
          {'item': 'q', 'liste': []},
          {'item': 'r', 'liste': []},
          {'item': 's', 'liste': []},
          {'item': 't', 'liste': []},
          {'item': 'u', 'liste': []},
          {'item': 'v', 'liste': []},
          {'item': 'w', 'liste': []},
          {'item': 'x', 'liste': []},
          {'item': 'y', 'liste': []},
          {'item': 'z', 'liste': []},
          {'item': '0', 'liste': []},
          {'item': '1', 'liste': []},
          {'item': '2', 'liste': []},
          {'item': '3', 'liste': []},
          {'item': '4', 'liste': []},
          {'item': '5', 'liste': []},
          {'item': '6', 'liste': []},
          {'item': '7', 'liste': []},
          {'item': '8', 'liste': []},
          {'item': '9', 'liste': []},
          {'item': '?', 'liste': []},
          {'item': '#', 'liste': []},
          {'item': '@', 'liste': []}
      ]
      // let listeAllContacts = []
      _.forEach(
        alphaListe,
        (alpha, key2) => {
          let listeAllContacts = []
          _.forEach(
            this.$store.state._StoreWatcheeBox.listeContactReseaux,
            (contact, key) => {
              // listeAllContacts.push(contact)
              if (contact.network === 'whatsapp') {
                // console.log('1er :', contact.profileName.substring(0, 1).toLowerCase())
                if (alpha.item === contact.profileName.substring(0, 1).toLowerCase()) {
                  listeAllContacts.push(contact)
                }
              } else if (contact.network === 'facebook') {
                // console.log('1er :', contact.lastName.substring(0, 1).toLowerCase())
                if (alpha.item === contact.lastName.substring(0, 1).toLowerCase()) {
                  listeAllContacts.push(contact)
                }
              }
            }
          )
          // console.log('listeAllContacts', listeAllContacts)
          if (listeAllContacts.length) {
            alpha.liste = listeAllContacts.sort()
          }
        }
      )
      console.log('alphaListe', alphaListe)
      return alphaListe
    },

    dataVisiteurComputed () {
      // console.log('dataVisiteurComputed')
      let visiteurDataSelected
      let index
      // console.log('this.contactSelected.visiteurID', this.contactSelected.visiteurID)
      // si le visiteur est en ligne
      if (!this.filterFront) {
        // console.log('visiteur online')
        index = _.findIndex(this.concatAllVisiteurs, {'visiteurID': this.contactSelected.visiteurID})
        // console.log('index 1 : ', index)
        if (index !== -1) {
          visiteurDataSelected = this.concatAllVisiteurs[index]
        }
      } else {
        // console.log('visiteur offline')
        index = _.findIndex(this.listeAllVisiteurs, {'visiteurID': this.contactSelected.visiteurID})
        // console.log('index 2 : ', index)
        if (index !== -1) {
          visiteurDataSelected = this.listeAllVisiteurs[index]
          visiteurDataSelected.histoChat = this.allDataVisiteurOpened.histoChat
        }
      }
      // console.log('index', index)
      if (index === -1) {
        // il faut recuperer le bon histoChat dans le store 'allDataVisiteurOpened'
        // c'est celui qui est mise à jour pour les messages visiteur offline en attente
        let MAJHistoCHat = _.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat)
        this.visiteurData.histoChat = MAJHistoCHat
        // c'est le visiteurDataSelected avec l'histoChat à jour pour les messages en attente
        visiteurDataSelected = this.visiteurData
      }
      // console.log('visiteurDataSelected', visiteurDataSelected)
      return {'cobrowsing': false, 'online': true, 'viewStatus': true, 'visiteurDatas': visiteurDataSelected, 'visiteurID': this.contactSelected}
    }
  }
}
</script>
<style scoped>
  .theme--light.v-expansion-panel .v-expansion-panel__container {
    border-top: 1px solid rgba(0,0,0,0);
  }
  .listContacts {
    margin-left: 46px;
  }
</style>



// WEBPACK FOOTER //
// src/components/trafic/Contact.vue